import conferenceSystemNoticeAvatar from './assets/conference-system-notice-avatar.png';
import conferenceSystemNoticeAvatarEn from './assets/conference-system-notice-avatar-en.png';

export const CONFERENCE_CHAT_PARTICIPANT_TYPE_SYSTEM = 99;
export const CONFERENCE_CHAT_SYSTEM_NOTICE_SOURCE_ID =
  'conference-notice-system';
export const CONFERENCE_CHAT_SYSTEM_NOTICE_NAME_CN = '大会通知';
export const CONFERENCE_CHAT_SYSTEM_NOTICE_NAME_EN = 'Message Alerts';
export const CONFERENCE_CHAT_SYSTEM_NOTICE_TITLE_CN = '系统通知';
export const CONFERENCE_CHAT_SYSTEM_NOTICE_TITLE_EN = 'System Notice';
export type ConferenceChatSystemParticipantLocale = 'zh' | 'en';

type ConferenceChatParticipantIdentity = {
  type?: number;
  sourceID?: string;
};

type ConferenceChatSystemParticipantSummaryInput = {
  participant?: ConferenceChatParticipantIdentity;
  nameCN?: string;
  nameEN?: string;
  avatar?: string;
  locale?: ConferenceChatSystemParticipantLocale;
};

export type ConferenceChatSystemParticipantSummary = {
  nameCN: string;
  nameEN: string;
  titleCN: string;
  titleEN: string;
  avatar?: string;
};

const trimValue = (value?: string) => value?.trim() || '';
const getAssetSrc = (asset: unknown) =>
  typeof asset === 'string' ? asset : (asset as { src?: string } | undefined)?.src || '';

export const CONFERENCE_CHAT_SYSTEM_NOTICE_AVATAR = getAssetSrc(
  conferenceSystemNoticeAvatar
);
export const CONFERENCE_CHAT_SYSTEM_NOTICE_AVATAR_EN = getAssetSrc(
  conferenceSystemNoticeAvatarEn
);

export const isConferenceChatSystemParticipant = (
  participant?: ConferenceChatParticipantIdentity
) =>
  participant?.type === CONFERENCE_CHAT_PARTICIPANT_TYPE_SYSTEM &&
  trimValue(participant?.sourceID) === CONFERENCE_CHAT_SYSTEM_NOTICE_SOURCE_ID;

export const normalizeConferenceChatParticipantType = (type?: number) => {
  if (type === 2 || type === 3 || type === CONFERENCE_CHAT_PARTICIPANT_TYPE_SYSTEM) {
    return type;
  }
  return 1;
};

export const buildConferenceChatSystemParticipantSummary = (
  input?: ConferenceChatSystemParticipantSummaryInput
): ConferenceChatSystemParticipantSummary | undefined => {
  if (!isConferenceChatSystemParticipant(input?.participant)) {
    return undefined;
  }

  const locale = input?.locale === 'en' ? 'en' : 'zh';
  const fallbackAvatar =
    locale === 'en'
      ? CONFERENCE_CHAT_SYSTEM_NOTICE_AVATAR_EN || CONFERENCE_CHAT_SYSTEM_NOTICE_AVATAR
      : CONFERENCE_CHAT_SYSTEM_NOTICE_AVATAR;

  return {
    nameCN: trimValue(input?.nameCN) || CONFERENCE_CHAT_SYSTEM_NOTICE_NAME_CN,
    nameEN: trimValue(input?.nameEN) || CONFERENCE_CHAT_SYSTEM_NOTICE_NAME_EN,
    titleCN: CONFERENCE_CHAT_SYSTEM_NOTICE_TITLE_CN,
    titleEN: CONFERENCE_CHAT_SYSTEM_NOTICE_TITLE_EN,
    avatar: trimValue(input?.avatar) || fallbackAvatar,
  };
};
